<div class="overlay-inner-wrapper">
  <div id="sammelWrapper">
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ 'Anlagenliste' | mrTranslate }}</span>
      </div>
      <div class="header-actions clr-align-items-center">
        <clr-toggle-container style="margin-top: 0px">
          <clr-toggle-wrapper>
            <input type="checkbox" clrToggle [(ngModel)]="isCheckedAll" />
            <label>{{ 'Alle Inspektionen' | mrTranslate }}</label>
          </clr-toggle-wrapper>
        </clr-toggle-container>

        <div class="btn-group btn-icon">
          @if (table()?.rows.length != filteredRows().length) {
            <button class="btn" (click)="filterStore.deleteAllFilters()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="filter-off" size="20" />
                <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                  {{ 'Alle Filter zurücksetzen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          }

          <app-all-selected-btn [(selected)]="selected" [all]="filteredRows()" />
        </div>

        <div class="btn-group btn-icon">
          @let disabled = !selected().length;

          <button class="btn" (click)="promptEvent()?.prompt()" [disabled]="!promptEvent()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="install" size="20" />
              <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                {{ 'Installiere PWA' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>

          <button class="btn" (click)="createSammel()" [disabled]="disabled">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="pdffile" size="20" />
              <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                {{ 'Sammelexport' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>

          @if (progVersion == 45 && authService?.token?.rights?.status > 2) {
            <button class="btn" (click)="createMessdatenExport()" [disabled]="disabled">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="vp" size="20" />
                <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                  {{ 'Messdatenexport für MessReg' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>

            @if (STDEL()) {
              <button class="btn" (click)="stammdel()" [disabled]="disabled">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="deletestamm" size="20" />
                  <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                    {{ 'Stammdaten löschen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
            <button class="btn" (click)="stammarchiv()" [disabled]="disabled">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="archive" size="20" />
                <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                  {{ 'Stammdaten archivieren' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>

            @if (PRDEL()) {
              <button class="btn" (click)="delpruef()" [disabled]="disabled">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="deleterow" size="20" />
                  <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                    {{ 'Prüfung löschen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
          }
        </div>

        <div class="btn-group btn-icon">
          <button class="btn" (click)="close()">
            <cds-icon [title]="'Beenden' | mrTranslate" size="20" shape="times" />
          </button>
        </div>
      </div>
    </header>

    <div class="limit-height">
      @if (table()?.columns.length) {
        <clr-datagrid
          class="datagrid-compact"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="selected()"
          (clrDgSelectedChange)="selected.set($event)"
          [clrDgRowSelection]="true"
          [clrDgItemsIdentityFn]="row => row?.[trackId()]">
          @for (column of table().columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <clr-dg-filter [attr.data-test-id]="'datagrid-sammel-col-filter-' + column.id">
                <app-column-filter
                  [column]="column"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                {{
                  column.id == 'KAV' ?
                    table().rows[0]?.KAV?.toString().includes('%') ?
                      'SAX'
                    : 'KAV'
                  : (column.id | titlecase | mrTranslate)
                }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="filteredRows()"
            [clrVirtualRowsTrackBy]="(_, row) => row?.[trackId()]">
            <clr-dg-row [clrDgItem]="row">
              @for (cell of table().columns; track cell.id) {
                <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
    </div>
  </div>
</div>
